import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Tab1Table1 from "./Tab1Table1";
import Tab1Table2 from "./Tab1Table2";
import {
  useGetUOMSearchMutation,
  useItemTaxTemplateMutation,
  useItemTaxCategoryMutation,
  useItemUOMMutation,
} from "../../../../store/api/itemapi";
import MultiFileInput from "../../../../Core/Fields/Floating/MultiFileInput";
const Tab1 = ({
  ItemCode,
  group,
  category,
  company,
  brand,
  ItemName,
  DefaultUnitOfMeasures,
  HSN_SAC,
  StandardSellingRate,
  Length_MM,
  Width_MM,
  Hieght_MM,
  Disabled,
  MaintainStock,
  HasBatchNo,
  autoCreateBatch,
  hasExpiryDate,
  retainSample,
  sampleQuantity,
  batchPrefix,
  HasSerialNo,
  SerialNoSetup,
  SerialNumberSeries,
  HasVariants,
  Description,
  Specification,
  Is_Ineligible_for_Input_Tax_Credit,
  Quality_Inspection_Template,
  Inspection_Required_before_Purchase,
  Inspection_Required_before_Delivery,
  Include_Item_In_Manufacturing,
  Supply_Raw_Materials_for_Purchase,
  setselected_uom_item_data,
  setRows,
  rows,
  setselected_tax_item_data,
  setRows1,
  rows1,
  onInputChange
}) => {
  // console.log('test:',ItemGroup)
  const [ItemUOMApi] = useItemUOMMutation();
  const [UOMSearchInput] = useGetUOMSearchMutation();

  const [ItemTaxTemplateApi] = useItemTaxTemplateMutation();
  const [ItemTaxCategoryApi] = useItemTaxCategoryMutation();
  const navigate = useNavigate();
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Input
              id="ItemCode"
              style={{
                height: "30px",
                border: ItemCode.Error ? "1px solid red" : "",
              }}
              label="Item Code"
              value={ItemCode.ItemCode}
              onChange={(e) => ItemCode.setItemCode(e.target.value)}
            />
          </div>
        </div>

        <div className="col-3 ">
          <div className={group.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={group.group_list}
              style={{
                height: "30px",
                border: group.Error ? "1px solid red" : "",
              }}
              label="Item Group"
              getOptionLabel={(item) =>
                item.isNew ? "+ Create New Item Group" : item.name
              }
              getOptionValue={(item) => item.name}
              value={group.select_group}
              createNewUrl="/master/itemgroup/create-item-group"
              createNewLabel="Create New Item Group"
              onChange={(val) => group.setselect_group(val)}

            />
          </div>
        </div>

        <div className="col-3 ">
          <div className={category.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={category.category_list}
              style={{
                height: "30px",
                border: category.Error ? "1px solid red" : "",
              }}
              label="Category"
              getOptionLabel={(item) =>
                item.isNew ? "+ Create New Category" : item.name
              }
              getOptionValue={(item) => item.name}
              createNewUrl="/master/itemgroup/create-item-group"
              createNewLabel="Create New Category"
              value={category.select_category}
              onChange={(val) => category.setselect_category(val)}
            />
          </div>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <SelectSearch
              list={company.company_list}
              style={{
                height: "30px",
                border: company.Error ? "1px solid red" : "",
              }}
              label="Company"
              getOptionLabel={(item) =>
                item.isNew ? "+ Create New Company" : item.name
              }
              getOptionValue={(item) => item.name}
              createNewUrl="/master/company/create-Company"
              createNewLabel="Create New Company"
              value={company.select_company}
              onChange={(val) => company.setselect_company(val)}
            />
          </div>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            {/* <SelectSearch
              list={brand.brand_list}
              style={{
                height: "30px",
                border: brand.Error ? "1px solid red" : "",
              }}
              label="Brand"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={brand.select_brand}
              onChange={(val) => brand.setselect_brand(val)}
            /> */}
            <SelectSearch
              list={brand.brand_list}
              label="Brand"
              getOptionLabel={(item) =>
                item.isNew ? "+ Create New Brand" : item.name
              }
              getOptionValue={(item) => item.name}
              value={brand.select_brand}
              onChange={(val) => brand.setselect_brand(val)}
              createNewUrl="/master/brand/create-brand"
              createNewLabel="Create New Brand"
            />

          </div>
        </div>

        <div className="col-3 ">
          <div className="mb-3">
            <Input
              style={{
                height: "30px",
                border: ItemName.Error ? "1px solid red" : "",
              }}
              id="ItemName"
              label="Item Name"
              value={ItemName.ItemName}
              onChange={(e) => ItemName.setItemName(e.target.value)}
            />
          </div>
        </div>

        <div className="col-3 ">
          <div
            className={
              DefaultUnitOfMeasures.Error ? `mb-3 errorborder` : `mb-3`
            }
          >
            <SelectSearch
              list={DefaultUnitOfMeasures.DefaultUnitOfMeasure_list}
              style={{
                height: "30px",
                border: DefaultUnitOfMeasures.Error ? "1px solid red" : "",
              }}
              label="Default Unit Of Measure"
              getOptionLabel={(item) =>
                item.isNew ? "+ Create New UOM" : item.name
              }
              getOptionValue={(item) => item.name}
              createNewUrl="/master/uom/create-uom"
              createNewLabel="Create New UOM"
              value={DefaultUnitOfMeasures.select_DefaultUnitOfMeasure}
              onChange={(val) =>
                DefaultUnitOfMeasures.setselect_DefaultUnitOfMeasure(val)
              }
            />
          </div>
        </div>
        <div className="col-3 ">
          <div className={HSN_SAC.Error ? `mb-3 errorborder` : `mb-3`}>
            <SelectSearch
              list={HSN_SAC.HSN_SAC_list}
              style={{
                height: "30px",
                border: HSN_SAC.Error ? "1px solid red" : "",
              }}
              label="HSN/SAC"
              getOptionLabel={(item) =>
                item.isNew ? "+ Create New HSN/SAC" : item.name
              }
              getOptionValue={(item) => item.name}
              createNewUrl="/master/gsthsncode/gst-hsn-create"
              createNewLabel="Create New HSN/SAC"
              value={HSN_SAC.select_HSN_SAC}
              onChange={(val) => HSN_SAC.setselect_HSN_SAC(val)}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="mb-3">
            <Input
              id="StandardSellingRate"
              label="Standard Selling Rate"
              style={{ height: "30px" }}
              value={StandardSellingRate.StandardSellingRate}
              onChange={(e) => StandardSellingRate.setStandardSellingRate(e.target.value)}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="mb-3">
            <Input
              id="Length_MM"
              label="Length (mm) (Unicommerce)"
              style={{ height: "30px" }}
              value={Length_MM.Length_MM}
              onChange={(e) => Length_MM.setLength_MM(e.target.value)}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="mb-3">
            <Input
              id="Width_MM"
              label="Width (mm) (Unicommerce)"
              style={{ height: "30px" }}
              value={Width_MM.Width_MM}
              onChange={(e) => Width_MM.setWidth_MM(e.target.value)}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="mb-3">
            <Input
              id="Hieght_MM"
              label="Height (mm) (Unicommerce)"
              style={{ height: "30px" }}
              value={Hieght_MM.Hieght_MM}
              onChange={(e) => Hieght_MM.setHieght_MM(e.target.value)}
            />
          </div>
        </div>
        <div className="col-2 ">
          <div className="mb-3">
            <Checkbox
              id="Disabled"
              label="Disabled"
              // checked={Disabled}
              value={Disabled?.Disabled || false}
              onChange={(val) => Disabled?.setDisabled?.(val)}
            />
          </div>
        </div>
        <div className="col-2 ">
          <div className="mb-3">
            <Checkbox
              id="MaintainStock"
              label="Maintain Stock"
              value={MaintainStock?.MaintainStock}
              onChange={(val) => MaintainStock?.setMaintainStock?.(val)}
            />
          </div>
        </div>



        <div className="col-2">
          <div className="mb-3">
            <Checkbox
              id="HasBatchNo"
              label="Has Batch No"
              value={HasBatchNo?.HasBatchNo || false}
              onChange={(val) => {
                HasBatchNo?.setHasBatchNo?.(val);
                if (!val) {
                  autoCreateBatch?.setAutoCreateBatch?.(false);
                  hasExpiryDate?.setHasExpiryDate?.(false);
                  retainSample?.setRetainSample?.(false);
                }
              }}
            />
          </div>
        </div>





        <div className="col-2 ">
          <div className="mb-3">
            <Checkbox
              id="HasSerialNo"
              label="Has Serial No"
              value={HasSerialNo?.HasSerialNo || false}
              onChange={(val) => HasSerialNo?.setHasSerialNo?.(val)}
            />
          </div>
        </div>
        <div className="col-4 ">
          <div className="mb-3">
            <Checkbox
              id="HasVariants"
              label="Has Variants"
              value={HasVariants?.HasVariants || false}
              onChange={(val) => HasVariants?.setHasVariants?.(val)}
            />
            <div
              style={{
                fontSize: "9px",
                color: "#00000099",
                marginLeft: "23px",
              }}
            >
              If this item has variants, then it cannot be selected in sales
              orders etc.
            </div>
          </div>
        </div>

        <div className="col-3">
          <div className="mb-3">
            <SelectSearch
              list={[{ name: "System Generated" }, { name: "Manual" }]}
              style={{
                height: "30px",
                border: SerialNoSetup?.Error ? "1px solid red" : "",
              }}
              label="Serial No Setup"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={SerialNoSetup?.SerialNoSetup || ""}
              onChange={(value) => SerialNoSetup?.setSerialNoSetup?.(value)}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="mb-3">
            <div style={{ flex: '1' }}>
              <div className="mb-3">
                <MultiFileInput
                  name="Item Image"
                  style={{ height: "30px" }}
                  setFile={(files) => onInputChange(files)}
                  // error={errors?.invoice_image}
                />
                {/* {errors?.invoice_image && <div className="error-text">Image This field is required</div>} */}

              </div>
            </div>
          </div>
        </div>
        {/* checked Has Serial No */}
        {HasSerialNo?.HasSerialNo && (
          <>

            <div className="col-3">
              <div className="mb-3">
                <Input
                  style={{ height: "30px" }}
                  id="SerialNumberSeries"
                  label="Serial Number Series"
                  placeholder="Serial Number Series"
                  value={SerialNumberSeries?.SerialNumberSeries || ""}
                  onChange={(e) =>
                    SerialNumberSeries?.setSerialNumberSeries?.(e.target.value)
                  }
                />
                <div
                  style={{
                    fontSize: "10px",
                    color: "#00000099",
                  }}
                >
                  Example: ABCD.##### If series is set and Serial No is not mentioned in transactions, then automatic serial number will be created based on this series. If you always want to explicitly mention Serial Nos for this item. leave this blank.
                </div>
              </div>
            </div>
          </>
        )}
        {/* end */}

        {/* checked HAS Batch No */}
        {HasBatchNo?.HasBatchNo && (
          <>
            <div className="col-2">
              <div className="mb-3">
                <Checkbox
                  id="AutoCreateBatch"
                  label="Automatically Create New Batch"
                  value={autoCreateBatch?.autoCreateBatch || false}
                  onChange={(val) => autoCreateBatch?.setAutoCreateBatch?.(val)}
                />
              </div>
            </div>

            <div className="col-2">
              <div className="mb-3">
                <Checkbox
                  id="HasExpiryDate"
                  label="Has Expiry Date"
                  value={hasExpiryDate?.hasExpiryDate || false}
                  onChange={(val) => hasExpiryDate?.setHasExpiryDate?.(val)}
                />
              </div>
            </div>

            <div className="col-2">
              <div className="mb-3">
                <Checkbox
                  id="RetainSample"
                  label="Retain Sample"
                  value={retainSample?.retainSample || false}
                  onChange={(val) => retainSample?.setRetainSample?.(val)}
                />
              </div>
            </div>

            {autoCreateBatch?.autoCreateBatch && (
              <>
                <div className="col-3">
                  <div className="mb-3">
                    <Input
                      style={{ height: "30px" }}
                      id="BatchPrefix"
                      label="Batch Number Series"
                      placeholder="Batch Number Series"
                      value={batchPrefix?.batchPrefix || ""}
                      onChange={(e) =>
                        batchPrefix?.setBatchPrefix?.(e.target.value)
                      }
                    />
                    <div
                      style={{
                        fontSize: "10px",
                        color: "#00000099",
                      }}
                    >
                      Example: ABCD.#####. If series is set and Batch No is not mentioned in transactions, then automatic batch number will be created based on this series. If you always want to explicitly mention Batch No for this item, leave this blank. Note: this setting will take priority over the Naming Series Prefix in Stock Settings.
                    </div>
                  </div>
                </div>

              </>
            )}
            {retainSample?.retainSample && (
              <>
                <div className="col-3">
                  <div className="mb-3">
                    <Input
                      style={{ height: "30px" }}
                      id="sampleQuantity"
                      label="Max Sample Quantity"
                      placeholder="Max Sample Quantity"
                      value={sampleQuantity?.sampleQuantity || ""}
                      onChange={(e) =>
                        sampleQuantity?.setsampleQuantity?.(e.target.value)
                      }
                    />

                  </div>
                </div>

              </>
            )}
          </>
        )}
        {/* end */}
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Description</p>
        </div>

        <div className="col-6">
          <div className="mb-3">
            <Textarea
              style={{
                height: "150px",
                border: Description?.Error ? "1px solid red" : "",
              }}
              label="Description"
              value={Description.Description}
              onChange={(e) => Description.setDescription(e.target.value)}
            />
          </div>
        </div>

        <div className="col-6">
          <div className="mb-3">
            <Textarea
              style={{
                height: "150px",
                border: Specification?.Error ? "1px solid red" : "",
              }}
              label="Specification"
              value={Specification.Specification}
              onChange={(e) => Specification.setSpecification(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Units of Measure </p>
        </div>

        <Tab1Table1
          setselected_uom_item_data={setselected_uom_item_data}
          rows={rows}
          setRows={setRows}
          list_uom_data={UOMSearchInput}
        />
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Taxes </p>
        </div>

        <div className="col-3 ">
          <div className="mb-3">
            <Checkbox
              id="Is_Ineligible_for_Input_Tax_Credit"
              label="Is Ineligible for Input Tax Credit"
              value={
                Is_Ineligible_for_Input_Tax_Credit?.Is_Ineligible_for_Input_Tax_Credit ||
                false
              }
              onChange={(val) =>
                Is_Ineligible_for_Input_Tax_Credit?.setIs_Ineligible_for_Input_Tax_Credit?.(
                  val
                )
              }
            />
          </div>
        </div>
        <Tab1Table2
          setselected_tax_item_data={setselected_tax_item_data}
          rows1={rows1}
          setRows1={setRows1}
          list_itemtax_data={ItemTaxTemplateApi}
          list_item_tax_category_data={ItemTaxCategoryApi}
        />
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Quality </p>
        </div>

        <div className="col-3 ">
          <div className="mb-3">
            <SelectSearch
              list={
                Quality_Inspection_Template.Quality_Inspection_Template_list
              }
              style={{
                height: "30px",
                border: Quality_Inspection_Template.Error
                  ? "1px solid red"
                  : "",
              }}
              label="Quality Inspection Template"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={
                Quality_Inspection_Template.select_Quality_Inspection_Template
              }
              onChange={(val) =>
                Quality_Inspection_Template.setselect_Quality_Inspection_Template(
                  val
                )
              }
            />
          </div>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Checkbox
              id="Inspection_Required_before_Purchase"
              label="Inspection Required before Purchase"
              value={
                Inspection_Required_before_Purchase?.Inspection_Required_before_Purchase ||
                false
              }
              onChange={(val) =>
                Inspection_Required_before_Purchase?.setInspection_Required_before_Purchase?.(
                  val
                )
              }
            />
          </div>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Checkbox
              id="Inspection_Required_before_Delivery"
              label="Inspection Required before Delivery"
              value={
                Inspection_Required_before_Delivery?.Inspection_Required_before_Delivery ||
                false
              }
              onChange={(val) =>
                Inspection_Required_before_Delivery?.setInspection_Required_before_Delivery?.(
                  val
                )
              }
            />
          </div>
        </div>
      </div>

      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Manufacturing </p>
        </div>

        <div className="col-3 ">
          <div className="mb-3">
            <Checkbox
              id="Include_Item_In_Manufacturing"
              label="Include Item In Manufacturing"
              value={
                Include_Item_In_Manufacturing?.Include_Item_In_Manufacturing ||
                false
              }
              onChange={(val) =>
                Include_Item_In_Manufacturing?.setInclude_Item_In_Manufacturing?.(
                  val
                )
              }
            />
          </div>
        </div>
        <div className="col-3 ">
          <div className="mb-3">
            <Checkbox
              id="Supply_Raw_Materials_for_Purchase"
              label="Supply Raw Materials for Purchase"
              value={
                Supply_Raw_Materials_for_Purchase?.Supply_Raw_Materials_for_Purchase ||
                false
              }
              onChange={(val) =>
                Supply_Raw_Materials_for_Purchase?.setSupply_Raw_Materials_for_Purchase?.(
                  val
                )
              }
            />
            <p
              style={{
                paddingLeft: "25px",
                paddingRight: "14px",
                fontWeight: 400,
                fontSize: "9px",
                lineHeight: "16px",
                letterSpacing: "0",
                color: "#00000099",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              If subcontracted to a vendor
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tab1;
